import script from "./New.vue?vue&type=script&setup=true&lang=js"
export * from "./New.vue?vue&type=script&setup=true&lang=js"

import "./New.vue?vue&type=style&index=0&id=5d088b80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d088b80"]])

export default __exports__